import { NAV_AND_SUBNAV_HEIGHT, NAV_HEIGHT } from '~/common/constants/page';
import { useAppShell } from '~/common/layout/AppShellContext';
import { APP_BREADCRUMB_HEIGHT } from '~/features/app/AppBreadcrumb';
import { useSidebarNav } from '~/features/app/SidebarNavContext';

interface Options {
  hasSubnav?: boolean;
}

// Returns the px offset a sticky table header (or similar sticky element)
// needs in order to tuck under the app's top chrome.
//
// Inside an `AppShell` that owns the page chrome, the sticky element must clear
// the shell's own sticky header (top bar + header row), so defer to the offset
// the shell publishes. Otherwise, when the sidebar navigation preview is opted
// in, the top chrome is just the AppBreadcrumb bar (subnavs collapse into the
// left sidebar tree, so `hasSubnav` is moot). When off, fall back to the legacy
// AppPageNavbar heights.
export const useStickyHeaderOffset = ({ hasSubnav = false }: Options = {}) => {
  const { isSidebarLayoutActive } = useSidebarNav();
  const { stickyHeaderOffset: appShellOffset } = useAppShell();

  if (appShellOffset != null) return appShellOffset;
  if (isSidebarLayoutActive) return APP_BREADCRUMB_HEIGHT;
  return hasSubnav ? NAV_AND_SUBNAV_HEIGHT : NAV_HEIGHT;
};
